/** Photographers type website/social values in all kinds of formats (with or without
 * https://, full domain vs bare handle) - these normalize whatever they entered into a
 * URL that actually opens instead of being treated as a broken relative link. */
export function normalizeUrl(value) {
  if (!value) return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
}

export function socialUrl(value, domain) {
  if (!value) return null;
  const trimmed = value.trim().replace(/^@/, "");
  if (!trimmed) return null;
  if (/^https?:\/\//i.test(trimmed) || trimmed.toLowerCase().includes(domain)) {
    return normalizeUrl(trimmed);
  }
  return `https://${domain}/${trimmed}`;
}
